import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';

import { 
    twitterColor,
    facebookBoxShadow,
    // instagramColor,
    // grayColor,
    // tumblrColor,
    linkedinColor,
    whiteColor 
} from 'assets/jss/material-kit-pro-react';



const useStyles = makeStyles((theme) => ({

  root: {
    //display: 'flex',
    //flexWrap: 'wrap',
    width: '100%',
    margin: '10px auto',
  },
  image: {
    width: '100%',
    height: 80,
    borderRadius: "6px !important",
    position: 'relative',
    backgroundColor : linkedinColor,
    //minHeight: '80px',
    [theme.breakpoints.down('xs')]: {
      width: '100% !important', // Overrides inline-style
      //height: '100%',
    },
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.5,
      },
      '& $imageMarked': {
        opacity: 0,
      },
      '& $imageTitle': {
        //border: '4px solid currentColor',
      },
    },
  },
  focusVisible: {},
  imageButton: {
    borderRadius: "6px !important",
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: whiteColor,//grayColor[8],
    ...facebookBoxShadow
  },
  imageSrc: {
    borderRadius: "6px !important",
    position: 'absolute',
    
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%',
  },
  imageBackdrop: {
    borderRadius: "6px !important",
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: twitterColor,
    opacity: 0,
    transition: theme.transitions.create('opacity'),
  },
  imageTitle: {
    position: 'relative',
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px ${theme.spacing(1) + 6}px`,
  },
  imageMarked: {
    //height: 3,
    //width: 18,
    //backgroundColor: theme.palette.common.white,
    position: 'absolute',
    bottom: -2,
    left: 'calc(50% - 9px)',
    transition: theme.transitions.create('opacity'),
  },
  
}));

export default function MakeButton(props) {
  const classes = useStyles();

  function handleClick(e){
    props.onClick && props.onClick(e)
  }

  return (
    <div className={classes.root}>
        <ButtonBase
          focusRipple
          key={props.id}
          id={props.id}
          name={props.id}
          className={classes.image}
          focusVisibleClassName={classes.focusVisible}
          style={{
            width: props.width,
          }}
          onClick={handleClick}
        >
          <div
            className={classes.imageSrc}
          />
          <div className={classes.imageBackdrop} />
          <div className={classes.imageButton}>
            {props.children}
          </div>
        </ButtonBase>
    </div>
  );
}